export default __webpack_public_path__ + "static/screenThirdSectionEnBig-fe6dc03e5d95460e853b9bb6f5a0f9f0.webp";